
export class TypeSelectDualPickListModel{

  id : number;
  text : string;
/**
 * @param {?} id
 * @param {?} text
 */
constructor(id, text) {
    this.id = id;
    this.text = text;
  }


}

function TypeSelectDualPickListModel_tsickle_Closure_declarations() {
/** @type {?} */
TypeSelectDualPickListModel.prototype.id;
/** @type {?} */
TypeSelectDualPickListModel.prototype.text;
}

